import { useState } from "react";
import Api from '../../../../component/Api';

function useMessages() {
    const [messages, setMessages] = useState([]);
    const [count, setCount] = useState(0);
    const [notiSubject, setNotiSubject] = useState("");
    const [notiMessage, setNotiMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [notiId, setNotiId] = useState(null);

    const fetchMessages = async () => {
        try {
            const { http } = Api();
            const response = await http.get(`/Admin/getNotificationsAndMessages`);

            if (response.data.status_code !== "ERR5") {
                const msgList = response.data.filter((o) => o.msg_type === "message");
                const unreadCount = msgList.filter((o) => o.status === "sent").length;
                setMessages(msgList);
                setCount(unreadCount);
            } else {
                setMessages([]);
                setCount(0);
            }
        } catch (error) {
            console.error("Error fetching messages:", error);
        }
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleViewModalOpen = (msgId, subject, message, status) => {
        setNotiSubject(subject);
        setNotiMessage(message);
        setShowModal(true);

        const markAsRead = async () => {
            try {
                const { http } = Api();
                await http.post(`/Admin/markAsRead`, { id: msgId });
                setNotiId(msgId);
                setMessages((prev) =>
                    prev.map((msg) =>
                        msg.id === msgId ? { ...msg, status: "read" } : msg
                    )
                );
                setCount((prev) => prev - 1);
            } catch (error) {
                console.error("Error in marking as read", error);
            }
        };

        if (status === "sent") {
            markAsRead();
        }
    };

    return {
        messages,
        count,
        notiSubject,
        notiMessage,
        showModal,
        notiId,
        fetchMessages,
        handleModalClose,
        handleViewModalOpen,
    };
}

export default useMessages;